import { render, staticRenderFns } from "./AddEstablishmentPage.vue?vue&type=template&id=457c4cc6"
import script from "./AddEstablishmentPage.vue?vue&type=script&lang=js"
export * from "./AddEstablishmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports